export const RCSCdrReports = (builder) => ({
    RCSCdrReports: builder.mutation({
        query: ({ page, limit, search, status, startDate, endDate }) => {
            const token = JSON.parse(localStorage.getItem('TOKEN'))?.token || '';
            return {
                url: process.env.REACT_APP_RCS_API_PORT + '/rcs_cdrs',
                method: 'GET',
                params: { page, limit, search, status, startDate, endDate },
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': token
                },
            };
        },
    }),
});